import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AdminLayout from "../../components/layout/AdminLayout";

// Menggunakan FaThLarge sebagai pengganti FaLayout yang tidak ada di library
import { 
  FaThLarge, 
  FaDatabase, 
  FaCalendarAlt, 
  FaFileDownload, 
  FaTimes 
} from "react-icons/fa";

export default function PetunjukAdmin() {
  const [showModal, setShowModal] = useState(false);
  const [openFeature, setOpenFeature] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    setShowModal(true);
  }, []);

  const petunjukFitur = [
    {
      nama: "Petunjuk Umum & Dashboard",
      icon: <FaThLarge className="text-blue-500 text-base" />,
      langkah: [
        "Masuk ke sistem menggunakan akun Admin yang telah terdaftar resmi.",
        "Pantau ringkasan data statistik sekolah secara real-time pada halaman Dashboard utama.",
        "Gunakan menu sidebar di sebelah kiri untuk berpindah antar modul pengelolaan data."
      ],
      infoTambahan: "Setiap aktivitas administratif akan terekam, pastikan akun Anda tidak digunakan oleh pihak lain."
    },
    {
      nama: "Kelola Data Master (Guru, Siswa, Kelas & Mapel)",
      icon: <FaDatabase className="text-green-500 text-base" />,
      langkah: [
        "Buka menu Data Guru, Data Siswa, Kelas, atau Mapel melalui sidebar admin.",
        "Gunakan tombol 'Tambah Data' untuk memasukkan entitas baru ke dalam sistem.",
        "Gunakan tombol aksi 'Edit' (ikon pensil) atau 'Hapus' (ikon tempat sampah) untuk memperbarui data operasional sekolah.",
        "Cetak atau buat Kartu Siswa yang berisi QR Code presensi langsung melalui sub-menu pengelolaan Data Siswa."
      ],
      infoTambahan: "Kartu siswa yang dicetak dari menu Data Siswa harus memiliki QR Code yang jelas agar bisa terbaca lancar saat melakukan scanning."
    },
    {
      nama: "Kelola Jadwal & Presensi",
      icon: <FaCalendarAlt className="text-orange-500 text-base" />,
      langkah: [
        "Masuk ke menu Pengaturan Jadwal untuk menyusun jam mengajar guru beserta kelas dan mata pelajarannya.",
        "Pantau jalannya absensi harian kelas melalui menu Monitoring Kehadiran.",
        "Kelola atau validasi pengajuan 'Jadwal Kosong' dan penunjukan 'Guru Pengganti' jika terdapat guru berhalangan hadir agar data laporan tetap sinkron."
      ]
    },
    {
      nama: "Laporan Rekapitulasi & Pengaturan Sistem",
      icon: <FaFileDownload className="text-purple-500 text-base" />,
      langkah: [
        "Buka menu Laporan untuk meninjau akumulasi tingkat kehadiran siswa per periode tertentu.",
        "Unduh rekap data absensi tersebut ke dalam format berkas dokumen untuk keperluan laporan berkala sekolah.",
        "Masuk ke halaman Pengaturan jika Anda perlu mengubah kredensial, hak akses pengguna, atau memperbarui kata sandi akun admin."
      ],
      infoTambahan: "Rekap data laporan yang diunduh sudah otomatis memuat keterangan detail absensi kelas termasuk riwayat guru pengganti."
    }
  ];

  const toggleFeature = (index) => {
    setOpenFeature(openFeature === index ? null : index);
  };

  const handleClose = () => {
    setShowModal(false);
    navigate("/admin");
  };

  return (
    <AdminLayout>
      <div className="p-4 sm:p-6">
        
        {showModal && (
          <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-2 sm:p-4">
            
            <div className="bg-white w-full max-w-lg rounded-xl shadow-2xl flex flex-col max-h-[90vh] animate-in fade-in zoom-in duration-300">
              
              {/* Header */}
              <div className="px-4 sm:px-6 py-3 sm:py-4 border-b bg-blue-600 text-white flex justify-between items-center shrink-0">
                <h3 className="text-base sm:text-lg font-bold">
                  Petunjuk Penggunaan SIPENSA (Admin)
                </h3>
                <button 
                  onClick={handleClose} 
                  className="p-1 rounded-lg hover:bg-blue-700 text-xl transition-colors flex items-center justify-center"
                >
                  <FaTimes />
                </button>
              </div>

              {/* Content */}
              <div className="flex-1 overflow-y-auto px-4 sm:px-6 py-4 space-y-3">
                <p className="text-xs text-gray-500 font-medium mb-2">
                  Silakan pilih fitur untuk melihat petunjuk pengelolaan:
                </p>

                {petunjukFitur.map((fitur, idx) => {
                  const isOpen = openFeature === idx;
                  return (
                    <div key={idx} className="border border-gray-200 rounded-lg overflow-hidden bg-gray-50/50">
                      
                      <button
                        onClick={() => toggleFeature(idx)}
                        className={`w-full px-4 py-3 flex justify-between items-center font-semibold text-sm transition-colors text-left ${
                          isOpen ? "bg-blue-50 text-blue-700" : "bg-white text-gray-700 hover:bg-gray-50"
                        }`}
                      >
                        <span className="flex items-center gap-2">
                          {fitur.icon}
                          <span>{fitur.nama}</span>
                        </span>
                        
                        <svg
                          className={`w-4 h-4 transform transition-transform duration-200 ${isOpen ? "rotate-180 text-blue-600" : "text-gray-400"}`}
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                        </svg>
                      </button>

                      {isOpen && (
                        <div className="p-4 bg-white border-t border-gray-100 space-y-3">
                          {fitur.langkah.map((isiLangkah, langkahIdx) => (
                            <div key={langkahIdx} className="flex gap-3 items-start">
                              <span className="text-blue-600 font-bold text-sm min-w-[18px]">
                                {langkahIdx + 1}.
                              </span>
                              <span className="text-gray-600 text-sm leading-relaxed">
                                {isiLangkah}
                              </span>
                            </div>
                          ))}

                          {fitur.infoTambahan && (
                            <div className="mt-2 p-3 bg-yellow-50 border-l-4 border-yellow-400 text-xs text-gray-700 rounded-r">
                              {fitur.infoTambahan}
                            </div>
                          )}
                        </div>
                      )}

                    </div>
                  );
                })}
              </div>

              {/* Footer */}
              <div className="px-4 sm:px-6 py-3 sm:py-4 bg-gray-50 border-t flex justify-end shrink-0">
                <button
                  onClick={handleClose}
                  className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-lg text-sm font-medium transition-colors"
                >
                  Saya Mengerti
                </button>
              </div>

            </div>
          </div>
        )}

      </div>
    </AdminLayout>
  );
}